package models

data class PhotoId(
    val id: String,
    val token: String
)
